import React from 'react';
import { IconDotsHorizontal } from '../../../base/icons/svg';
import Button from '../../../base/ui/components/web/Button';
const ParticipantActionEllipsis = ({ accessibilityLabel, onClick }) => (React.createElement(Button, { accessibilityLabel: accessibilityLabel, icon: IconDotsHorizontal, onClick: onClick, size: 'small' }));
export default ParticipantActionEllipsis;
